"use client";

import { useEffect } from "react";
import { initCSPDebugger } from "@/utils/csp-debugger";

export default function CSPDebugger() {
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      initCSPDebugger();
    }
  }, []);

  return null; // This component doesn't render anything
}
